import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sbaAxios } from "../../utils/sbaAxios";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { SBADropDown } from "../../UiComponents/SBADropDown";
import { DateRangePicker } from "rsuite";
import { getUserPageTracking } from "../../../config/apiConfig";
import { getAllUsers } from "../../actions/UserAction";
import moment from "moment";
import download from "../../../Images/download.svg";
import { exportToExcelUsingRef } from "../../utils/excelExporter";
import { AgGridReact } from "ag-grid-react";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";

export const UserPageTracking = () => {
  const dispatch = useDispatch();
  const userPageTrackingRef = useRef();

  const emptyState = {
    FromUserId: "",
    AccessedRoute: "",
    FromIp: "",
    BrowserUsed: "",
    FromDate: "",
    ToDate: "",
  };

  const [render, setRender] = useState(true);
  const [fieldData, setFieldData] = useState(emptyState);
  const [dropDownValue, setDropDownValue] = useState({
    Fullname: "",
    UserId: 0,
  });
  const [startDate, setStartDate] = useState(moment().subtract(7, "days"));
  const [endDate, setEndDate] = useState(moment());
  const [userPageData, setUserPageData] = useState();
    const [dateRange, setDateRange] = useState([new Date(moment().subtract(7, "days")), new Date(moment())]);
  useEffect(() => {
    document.title = `User Page Tracking`;
    dispatch(getAllUsers());
    getUserPageTrackingData(
      fieldData.FromUserId,
      fieldData.FromIp,
      fieldData.AccessedRoute,
      fieldData.BrowserUsed,
      fieldData.FromDate,
      fieldData.ToDate
    );
    setRender(false);
  }, [render]);

  const getUserPageTrackingData = async (
    fromUserId,
    fromIp,
    accessedRoute,
    browserUsed,
    fromDate,
    toDate
  ) => {
    try {
      const response = await sbaAxios({
        url: `${getUserPageTracking}?&fromUserId=${fromUserId}&fromIp=${fromIp}&accessedRoute=${accessedRoute}&browserUsed=${browserUsed}&fromDate=${fromDate}&toDate=${toDate}`,
        method: "get",
      });
      setUserPageData(response);
    } catch (error) {
      console.error("Error fetching family data:", error);
    }
  };

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  const Users = Gstate.Users.Users || [];

  const pageTrackingColDef = [
    {
      headerName: "User Name",
      field: "UserName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Route",
      field: "AccessedRoute",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "IP Address",
      field: "FromIP",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Session Id",
      field: "SessionId",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Browser Info",
      field: "BrowserUsed",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Access Date",
      field: "CreatedDate",
      sort: "desc",
      filter: "agTextColumnFilter",
      valueFormatter: (params) => {
        const formattedDate = moment(params.value).format("MM/DD/YYYY h:mm A");
        return formattedDate;
      },
    },
  ];

  const onDropDownChange = async (e) => {
    setDropDownValue(e.target.value);
    setFieldData({ ...fieldData, ["FromUserId"]: e.value.UserId });
  };

  const handleDateChange = (e) => {
   
      if (e) {

          const newStartDate = e.value.start !== null ? e.value.start : dateRange[0];
          const newEndDate = e.value.end !== null ? e.value.end : dateRange[1];
          setDateRange([newStartDate, newEndDate])
          setStartDate(newStartDate);
          setEndDate(newEndDate);    
         setFieldData({
        ...fieldData,
          ["FromDate"]: newStartDate,
          ["ToDate"]: newEndDate,
      });
    }
  };

  const editNameChange = (e) => {
    setFieldData({ ...fieldData, [e.target.name]: e.target.value });
  };

  const enterButtonClick = () => {
    getUserPageTrackingData(
      fieldData.FromUserId,
      fieldData.FromIp,
      fieldData.AccessedRoute,
      fieldData.BrowserUsed,
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD")
    );
  };

  let Level = [
    { BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` },
  ];

  Level = render
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `User Page Tracking Report`,
          Routes: `${UrlPath.UserPageTracking}`,
        },
      ];

  const defaultColDef = {
    sortable: false,
    floatingFilter: true,
    flex: 1,
  };

  return (
    <>
      <TopBar label={"User Page Tracking"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="bg-white p-3 border rounded">
            <div className="d-flex">
              <div className="col-md-4">
                <div className="mb-4">
                  <span className="fw-medium">User</span>
                  <div>
                    <SBADropDown
                      className="w-75"
                      textField={"Fullname"}
                      valueField={"UserId"}
                      data={Users}
                      value={dropDownValue}
                      onChange={(e) => onDropDownChange(e)}
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <span className="fw-medium">From IP</span>
                  <input
                    type="text"
                    className="form-control w-75"
                    name="FromIp"
                    value={fieldData.FromIp}
                    onChange={(e) => editNameChange(e)}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-4">
                                  <span className="fw-medium">Date Range</span>
                                  <div style={{width:"70%"}}>

                                  <SBDateRangePicker
                                      value={{ start: dateRange[0], end: dateRange[1] }}
                                      onChange={(e) => { handleDateChange(e) }}

                                  />
                                  </div>
                  {/*<DateRangePicker*/}
                  {/*  className="SbaDateRage text-dark w-75"*/}
                  {/*  placeholder="Select Date Range"*/}
                  {/*  value={[*/}
                  {/*    startDate ? moment(startDate).toDate() : new Date(),*/}
                  {/*    endDate ? moment(endDate).toDate() : new Date(),*/}
                  {/*  ]}*/}
                  {/*  format="MM/dd/yyyy"*/}
                  {/*  block*/}
                  {/*  character=" - "*/}
                  {/*  onChange={handleDateChange}*/}
                  {/*/>*/}
                </div>
                <div className="mb-4">
                  <span className="fw-medium">Browser Used</span>
                  <input
                    type="text"
                    className="form-control w-75"
                    name="BrowserUsed"
                    value={fieldData.BrowserUsed}
                    onChange={(e) => editNameChange(e)}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-4">
                  <span className="fw-medium">Accessed Route</span>
                  <input
                    type="text"
                    className="form-control w-75"
                    name="AccessedRoute"
                    value={fieldData.AccessedRoute}
                    onChange={(e) => editNameChange(e)}
                  />
                </div>
                <div className="mb-4">
                  <button
                    className="p-sm-btn mx-1 mt-4"
                    onClick={enterButtonClick}
                  >
                    Enter
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-12 d-flex justify-content-end">
              <button
                type="button"
                className="p-sm-btn mx-1"
                onClick={() => {
                  exportToExcelUsingRef(
                    userPageTrackingRef,
                    "user Page Tracking"
                  );
                }}
              >
                <img src={download} alt="Excel" />
                Export
              </button>
            </div>

            <div className="ag-theme-alpine m-1 " style={{ height: 550 }}>
              <AgGridReact
                ref={userPageTrackingRef}
                columnDefs={pageTrackingColDef}
                defaultColDef={defaultColDef}
                rowData={userPageData}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
